import axios from "../axios";

class UserService {

  static Instance() {
    return new UserService();
  }

  fetchUsers(request) {
    return axios.post("/api/user/list/org", request);
  }

  fetchAllUsers(request) {
    return axios.post("/api/user/list/all", request);
  }

  downloadImportTemplate() {
    return axios.get("/api/user/import/format/generate", {
      responseType: "blob",
    });
  }

  uploadUserData(formData) {
    return axios.post("/api/user/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  // exportToExcel(request) {
  //   return axios.post("/api/org/list/export", request, {
  //     responseType: "blob",
  //   });
  // }

  exportToExcel(request) {
    return axios.post("/api/user/list/export", request, {
      responseType: "blob",
    });
  }

  createUser(request) {
    return axios.post("/api/user/", request);
  }

  updateUser(request) {
    return axios.post("/api/user/update", request);
  }

  getTimezones() {
    return axios.get("/api/user/timezones");
  }
}

export default UserService.Instance();